export function isTouchDevice(): boolean {
  // https://github.com/microsoft/vscode/issues/127822#issuecomment-874324028
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}
